module.exports = __webpack_public_path__ + "img/fl.16a065b3.png";